import { OnboardingForm, ProfileForm } from "utils/types/OnboardingForms";
import { api } from "./api";

export const onboardingFormsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        NeedsGuaranteeOnboardingForm: builder.query<any, void>({
            query: () => ({
                url: "/Guarantee/NeedsGuaranteeOnboardingForm",
                method: "GET"
            })
        }),
        GetGuaranteeOnboardingForm: builder.query<OnboardingForm, void>({
            query: () => ({
                url: "/Guarantee/GetGuaranteeOnboardingForm",
                method: "GET"
            })
        }),
        SaveProfileGuaranteeOnboardingForm: builder.mutation<any, ProfileForm>({
            query: (body) => ({
                url: "/Guarantee/SaveProfileGuaranteeOnboardingForm",
                method: "POST",
                body: body
            })
        }),
        SaveScoresGuaranteeOnboardingForm: builder.mutation<any, any>({
            query: (body) => ({
                url: "/Guarantee/SaveScoresGuaranteeOnboardingForm",
                method: "POST",
                body: body
            })
        })
    })
})

export const {
    useNeedsGuaranteeOnboardingFormQuery,
    useLazyNeedsGuaranteeOnboardingFormQuery,
    useGetGuaranteeOnboardingFormQuery,
    useLazyGetGuaranteeOnboardingFormQuery,
    useSaveProfileGuaranteeOnboardingFormMutation,
    useSaveScoresGuaranteeOnboardingFormMutation
} = onboardingFormsApi;